import { classNames } from '@vkontakte/vkjs';
import { Footnote, Paragraph } from '@vkontakte/vkui';
import { TextWithIcon } from '@dui/TextWithIcon';
import { TypingIcon } from '@dui/icons';
import { useCheckDesktop } from '@dui';
import styles from './ChatCellBaseStatus.module.css';

interface ChatCellBaseStatusProps {
  type: 'typing' | 'unavailable';
  text: string;
}

export function ChatCellBaseStatus(props: ChatCellBaseStatusProps) {
  const { text, type } = props;

  const isDesktop = useCheckDesktop();
  const WrapperText = isDesktop ? Footnote : Paragraph;

  return (
    <WrapperText
      className={classNames(styles.root, styles[`root__type_${type}`])}
      Component={TextWithIcon}
      {...{ before: type === 'typing' && <TypingIcon /> }}
    >
      {text}
    </WrapperText>
  );
}
